import { render } from "./HTTPCreate.vue?vue&type=template&id=5532da7e&ts=true"
import script from "./HTTPCreate.vue?vue&type=script&lang=ts"
export * from "./HTTPCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__